import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import React, { Fragment } from 'react';
import { AssetsLabel, PercentLabel } from '../../Labels';
export var formatter = [{
  productType: 'deposit',
  minInvestment: function minInvestment(entity) {
    return React.createElement(Fragment, null, "M\xEDnimo: ", React.createElement(AssetsLabel, {
      decimals: 0,
      value: Number(entity.minInvestment)
    }));
  },
  commission: function commission(entity) {
    return React.createElement(Fragment, null, "TAE: ", React.createElement(PercentLabel, {
      value: Number(entity.commission),
      decimals: 2
    }));
  }
}];
export var getProductsHighlights = function getProductsHighlights(entity, productType) {
  var productTypeFormatter = formatter.find(function (item) {
    return item.productType === productType.api;
  });
  if (productTypeFormatter) {
    return {
      commission: productTypeFormatter.minInvestment(entity),
      minInvestment: productTypeFormatter.commission(entity)
    };
  }
  return {
    commission: entity.minInvestment,
    minInvestment: entity.commission
  };
};